---
title: Apps and Browser Extensions
description: Download desktop and mobile apps for macOS, Windows, Linux, iOS, and Android. As well as Browser Extensions.
category: Basics
updated: 2026-09-03
image: https://updates.kinopio.club/pages/help/app-icon-mac.png
---

# Desktop and Mobile Apps

<img src="https://updates.kinopio.club/pages/help/app-icon-mac.png" class="no-shadow" style="width: 100px"/>

[Download desktop apps](https://dl.todesktop.com/201223j48l03cxi) for macOS, Windows, or Linux

[Download iOS app](https://apps.apple.com/us/app/kinopio/id6448743101)

Or add the site to your Android phone homescreen by following the instructions in `About → Apps and Extensions`

<img src="https://updates.kinopio.club/pages/help/posts/apps/dialog.webp" class="small"/>

## Browser Extensions

For quickly recording thoughts, inspirations, and urls to your [Inbox](/help/inbox/) while you're out making waves on the world wide web.

Download for:

- [Firefox](https://addons.mozilla.org/en-US/firefox/addon/add-to-kinopio)
- [Chrome, Vivaldi, Edge, Brave](https://chrome.google.com/webstore/detail/kinopio/hodmmkfpchpgmaemlicohlkiigpejakn)
- [Safari](https://apps.apple.com/app/add-to-kinopio/id1614926102)

<img src="https://us-east-1.linodeobjects.com/kinopio-uploads/IWdfvX-mofsE8vS3b2gF2/firefox-extension.webp" class="large">

## SMS, Telegram, Zapier and more Integrations

Kinopio is also supported by [phonetonote](https://phonetonote.com/), which lets you add cards to your inbox via SMS, Telegram, Zapier, Email, Alfred, and more. API keys saved to phonetonote are encrypted and your messages are never stored there.

## Pro-Tips

The desktop app supports tabs and page refreshing like a web browser. Unlike a web browser, you can *really* shrink the window to help keep your tasks visible while you work.

<img src="https://updates.kinopio.club/pages/help/posts/apps/app-small.webp" class="medium"/>
